<template>
    <div class="pageContent view-aside-large">
        <div class="pageContent-in pageContent-in--videos">
            <calculation-aside-steps></calculation-aside-steps>
            <main class="pageContent-main pageContent-main--aside-steps">
                <calculation-container>
                    <div class="textcontent">
                        <h1 class="calculator-titleSmall">Nezávazná poptávka materiálu a práce</h1>
                    </div>

                    <calculation-demand-information-form-container @calculation-demand-created="onCreate" :simplified-form="true"></calculation-demand-information-form-container>
                    <router-link v-if="selectedConstructionId && selectedProjectSlug"
                                 :to="{name: 'calculation.construction', params: {projectSlug: selectedProjectSlug, constructionId: selectedConstructionId}}"
                                 class="calculator-backLink">
                        Zpět na soupis materiálu
                    </router-link>
                </calculation-container>
            </main>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import CalculationContainer from '../CalculationContainer';
import ErrorState from '../../error/ErrorState';
import CalculationDemandInformationFormContainer from './DemandInformationFormContainer';
import CalculationAsideSteps from "../calculator/construction/aside/AsideSteps";

export default {
    name:       'CalculationDemandInformationWorkIncludedContainer',
    components: {
        CalculationAsideSteps,
        ErrorState,
        CalculationContainer,
        CalculationDemandInformationFormContainer,
    },
    mounted() {
        if ((null === this.selectedConstructionId && null === this.bimId)) {
            this.$router.push({ name: 'calculation.projectSelect' });
        }
    },
    computed:   {
        ...mapGetters('calculation', ['selectedProjectSlug', 'selectedConstructionId', 'bimId', 'contactId', 'calculatedConstructionMaterial']),
    },
    methods:    {
        onCreate(data) {
            this.remarketingDataLayer(data);
            this.$router.push({ name: 'calculation.sentWorkIncluded' });
        },
        remarketingDataLayer({ requestData, response }) {
            const products = requestData.products.map((construction) => {
                return construction.products.map(({ consumption, id, name }) => {
                    return {
                        id, name, quantity: consumption, category: construction.name
                    };
                })
            }).flat();
            dataLayer.push({
                'event':        'calculator',
                'step':         5,
                'newsletter':   requestData.demandInformation.mktApproval,
                'ecommerce':    {
                    'purchase': {
                        'actionField': { 'id': response.id, 'option': 'poptat vcetne prace' },
                        'products':    products,
                    }
                },
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/calculation/demand/DemandInformationWorkIncludedContainer.vue